import React from 'react';
import { Chip } from '@mui/material';
import {
  HourglassEmpty,
  CheckCircle,
  Undo,
  Cancel,
} from '@mui/icons-material';

const ConsignmentStatusChip = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return {
          label: 'Pending',
          color: 'warning',
          icon: <HourglassEmpty />,
        };
      case 'sold':
        return {
          label: 'Sold',
          color: 'success',
          icon: <CheckCircle />,
        };
      case 'returned':
        return {
          label: 'Returned',
          color: 'info',
          icon: <Undo />,
        };
      case 'expired':
        return {
          label: 'Expired',
          color: 'error',
          icon: <Cancel />,
        };
      default:
        return {
          label: status || 'Unknown',
          color: 'default',
          icon: null,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      icon={config.icon}
    />
  );
};

export default ConsignmentStatusChip;
